import { State } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { JournalStateModel } from '../../../types/journal';

@State<JournalStateModel>({
  name: 'journal',
  defaults: {},
})
@Injectable()
export class JournalState {}
